import { GraphQLQuery } from '@settings/services/graphQLClient/GraphQLClient';
import gql from 'graphql-tag';

import { TransportUnloadingCondition } from '../interface';

/**
 * Результат ответа
 */
export interface UnloadingConditionResponse {
  items: TransportUnloadingCondition[];
}

/**
 * Запрос загрузки данных по условиям разгрузки
 */
export class UnloadingConditionQuery implements GraphQLQuery<null> {
  readonly query: any;

  readonly variables: null;

  constructor(ids?: any[]) {
    this.variables = null;
    this.query = gql`
            query __LOAD_UNLOADING_CONDITIONS__ {
                items: transport_unloading_condition_list(
                    limit: 1000000
                    ${
                      ids && ids.length > 0
                        ? `where:{id:{_in: [${ids.map((id) => `"${id}"`).join(',')}]}}`
                        : ``
                    }
                ) {
                    code
                    default_name
                    id
                    is_last_shoulder_only
                    is_terminal_allowances_included
                    is_terminal_services_included_on_loading
                    is_terminal_services_included_on_unloading
                    is_unloading_on_non_terminal_only
                    localized_names
                }
            }
        `;
  }
}
